// Configuração do Chatwoot
// A URL base pode ser configurada via variável de ambiente REACT_APP_CHATWOOT_URL

const CHATWOOT_BASE_URL = process.env.REACT_APP_CHATWOOT_URL || 'https://chat.omniflex.com.br';
const CHATWOOT_ACCOUNT_ID = process.env.REACT_APP_CHATWOOT_ACCOUNT_ID || '1';

/**
 * Gera a URL completa para uma conversa no Chatwoot
 * @param {string|number} conversationId - ID da conversa (pode ser display_id ou conversation_id)
 * @returns {string} URL completa da conversa
 */
export const getConversationUrl = (conversationId) => {
  if (!conversationId) return '';
  return `${CHATWOOT_BASE_URL}/app/accounts/${CHATWOOT_ACCOUNT_ID}/conversations/${conversationId}`;
};

/**
 * Abre uma conversa no Chatwoot em uma nova aba
 * @param {string|number} conversationId - ID da conversa
 */
export const openConversation = (conversationId) => {
  const url = getConversationUrl(conversationId);
  if (url) {
    window.open(url, '_blank');
  }
};

export { CHATWOOT_BASE_URL, CHATWOOT_ACCOUNT_ID };
